import { ISalesTeamCoverage } from 'legacy/lut/classes/models/salesTeam'

const getModifiedTime = (agent: ISalesTeamCoverage) => {
  const modifiedTime = Date.parse(agent.modified)

  return Number.isNaN(modifiedTime) ? 0 : modifiedTime
}

export function getSortedAgents(agents: ISalesTeamCoverage[]) {
  return agents.sort((a, b) => {
    if (a.isLeadPBM !== b.isLeadPBM) {
      return a.isLeadPBM ? -1 : 1
    }

    if (a.isLeadPBM) {
      return 0
    }

    return getModifiedTime(b) - getModifiedTime(a)
  })
}
